import { Component, EventEmitter, Input, Output, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';
import { ResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';

@Component( {
    selector: 'res-research-infrastructure-edit-research-results-tab',
    templateUrl: './research-infrastructure-edit-research-results-tab.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureEditResearchResultsTabComponent)],
} )
export class ResearchInfrastructureEditResearchResultsTabComponent {
    @Input() researchInfrastructure: ResearchInfrastructure;
    @Output() routerContextChange = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    public predecessorProjectId: number;
    public parentProjectId: number;

    /**
     * EventEmitter implementation to save this.project
     * to global-data-service - page leave navigation
     */
    public onRouterContextChange() {
        this.routerContextChange.emit();
    }

    /**
     * implementation of publicationChanges to set publications on project
     *
     * @param event Publication[] containing changed publications
     */
    public onPublicationsChange( event: Publication[] ): void {
        this.researchInfrastructure.publications = event;
    }
}
